import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import './Hero.css';

function Hero() {
  const revealRef = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="hero grid-bg reveal" ref={revealRef}>
      <div className="hero-container">
        <div className="hero-content">
          <div className="status-badge mono">
            <span className="status-dot"></span>
            Open for opportunities
          </div>

          <h1 className="hero-title">
            <span className="title-line">STANLEY</span>
            <span className="title-line outline">OKAFOR</span>
          </h1>

          <p className="hero-subtitle">
            Developer, aspiring coach, and perpetual work-in-progress.
            I build things for the web and try to get better at
            everything — one rep at a time.
          </p>

          <div className="hero-actions">
            <a href="#projects" className="btn btn-primary">
              View Projects
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M7 17L17 7M17 7H7M17 7V17"/>
              </svg>
            </a>
            <a href="/Stanley_Okafor_Resume.pdf" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
              Resume
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                <polyline points="15 3 21 3 21 9"/>
                <line x1="10" y1="14" x2="21" y2="3"/>
              </svg>
            </a>
            <a href="#contact" className="btn btn-secondary">
              Get in Touch
            </a>
          </div>
        </div>

        <div className="hero-image-wrapper">
          <img
            src="/images/look.jpeg"
            alt="Stanley Okafor"
            className="hero-photo"
          />
        </div>
      </div>

      <div className="tech-marquee">
        <div className="marquee-content">
          <span>JAVASCRIPT</span>
          <span className="separator">{"\u2022"}</span>
          <span>REACT</span>
          <span className="separator">{"\u2022"}</span>
          <span>PYTHON</span>
          <span className="separator">{"\u2022"}</span>
          <span>NODE.JS</span>
          <span className="separator">{"\u2022"}</span>
          <span>MONGODB</span>
          <span className="separator">{"\u2022"}</span>
          <span>DOCKER</span>
          <span className="separator">{"\u2022"}</span>
          <span>FOOTBALL</span>
          <span className="separator">{"\u2022"}</span>
          <span>AFROBEATS</span>
          <span className="separator">{"\u2022"}</span>
          <span>R&B</span>
          <span className="separator">{"\u2022"}</span>
          <span>SELF-IMPROVEMENT</span>
          <span className="separator">{"\u2022"}</span>
          <span>JAVASCRIPT</span>
          <span className="separator">{"\u2022"}</span>
          <span>REACT</span>
          <span className="separator">{"\u2022"}</span>
          <span>PYTHON</span>
          <span className="separator">{"\u2022"}</span>
          <span>NODE.JS</span>
          <span className="separator">{"\u2022"}</span>
          <span>MONGODB</span>
          <span className="separator">{"\u2022"}</span>
          <span>DOCKER</span>
          <span className="separator">{"\u2022"}</span>
          <span>FOOTBALL</span>
          <span className="separator">{"\u2022"}</span>
          <span>AFROBEATS</span>
          <span className="separator">{"\u2022"}</span>
          <span>R&B</span>
          <span className="separator">{"\u2022"}</span>
          <span>SELF-IMPROVEMENT</span>
          <span className="separator">{"\u2022"}</span>
        </div>
      </div>
    </section>
  );
}

export default Hero;
